export const SALES_REGIONS = [
  {
    id: 'APAC',
    displayValue: 'APAC',
  },
  {
    id: 'EMEA',
    displayValue: 'EMEA',
  },
  {
    id: 'JAPAN',
    displayValue: 'Japan',
  },
  {
    id: 'US',
    displayValue: 'US',
  },
];
